module.exports = __webpack_public_path__ + "static/media/scottkevin97.95831aac.png";